import { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';

import { AuthContext } from '../../contexts/AuthContext';
import { parseStringOr } from '../../components/App/AppxUtils';
import { PageView, PageViewSection } from '../../components/PageView';

import PlanCard from './PlanCard';

import './index.css';


export default function Zone() {
    const { t } = useTranslation('appxweb');
    const location = useLocation();
    const { doModelAction } = useContext(AuthContext);
    const [ loading, setLoading ] = useState(false);
    const [ zone, setZone ] = useState(null);
    const [ plans, setPlans ] = useState([]);
    const query = new URLSearchParams(location.search);
    const zoneApiCode = query.get('zoneApiCode');

    useEffect(() => {
        async function fetchData() {
            let apiCode = parseStringOr(zoneApiCode, "");

            if (apiCode !== "") {
                const response = await doModelAction({
                    model: 'zone',
                    action: 'getplansandzonebyapicode',
                    data: {
                        apiCode: apiCode,
                    }
                });

                if (response != null && response?.data) {
                    setZone(response.data.zone);
                    setPlans(response.data.plans);
                }
            }

            setLoading(false);
        }

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ zoneApiCode ]);

    return (
        <PageView
            leadText={t('Plan.leadText')}
            title={t('Plan.title')}
            subTitle={zone?.publicName}
            notes={zone?.publicNotes}
            loading={loading}
        >
            <PageViewSection
                className="plan-section"
                title={t('Plan.section_title')}
        >
                {plans.length > 0 ? (
                <Row
                    gutter={16}
                    wrap={true}
                >
                    {plans.map((plan, idx) => (
                    <Col key={`pland-card-${plan.id}-${idx}`} flex="auto" xs={24} sm={12}>
                        <PlanCard plan={plan} bgColor={idx%2 === 0 ? "light" : "dark"} />
                    </Col>
                    ))}
                </Row>
                ): (<p>{t('Plan.no_plans')}</p>)}
            </PageViewSection>
        </PageView>
    );
}

